export const isStockNegative = (value: string) => {
    if (value?.includes('-')) {
        return true
    } else {
        return false
    }
}
export const handleStockIsNegativeTextColor = (value: string) => {
    if (isStockNegative(value)) {
        return 'text-red-BA'
    } else {
        return 'text-green-43'
    }
}